<template>
  <div>
    <el-row class="toolbar">
      <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
        <el-tooltip content="通过前后端路由比对，实现路由的新增、删除、更新" placement="top" effect="dark">
          <el-button icon="el-icon-refresh" type="primary" @click="handleSyncBtnClick">一键同步路由资源</el-button>
        </el-tooltip>
        <el-button icon="el-icon-plus" type="primary" @click="handleAddBtnClick">新增</el-button>
      </el-col>
    </el-row>

    <el-table ref="routeTree" calss="tableTree" row-key="id" v-loading="loading" element-loading-text="正在加载..."
              :data="routeTree" :tree-props="{ children: 'children' }">
      <el-table-column prop="title" label="标题" show-overflow-tooltip/>
      <el-table-column prop="path" label="路径" show-overflow-tooltip/>
      <el-table-column label="是否需要授权">
        <template v-slot="{ row:route }">
          {{ route.isRequiredAuth ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column prop="category" label="权限分类" :formatter="categoryFormatter"/>
      <el-table-column label="是否菜单">
        <template v-slot="{ row:route }">
          {{ route.isMenu ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column prop="menuIndex" label="菜单索引">
      </el-table-column>
      <el-table-column prop="menuBadge" label="菜单徽标">
      </el-table-column>
      <el-table-column label="操作">
        <template v-slot="{ row:route }">
          <el-button type="text" @click="handleEditBtnClick(route)">编辑</el-button>
          <el-dropdown @command="handleDropDownCommand" trigger="click">
            <span class="el-dropdown-link">
              更多<em class="el-icon-arrow-down el-icon--right"></em>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="{name:'add',data:route}">新增子路由</el-dropdown-item>
              <el-dropdown-item :command="{name:'delete',data:route}">删除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>

    <!-- 使用对话框新增编辑路由 -->
    <el-dialog width="30%" v-if="dialogVisible"
               :title="dialogTitle" :visible="dialogVisible" :close-on-click-modal="false"
               @close="handleDialogClose">
      <component :is="currentComponent.name" v-bind="currentComponent.props" @close="handleComponentClose"/>
    </el-dialog>
  </div>
</template>

<script>
import {noticeManager} from "@zhoujianhui/vip-core"
import RouteAdd from "./RouteAdd"
import ChildRouteAdd from "./ChildRouteAdd"
import RouteEdit from "./RouteEdit"
import routeService from "../service/route-service"
import routeCategory from "../model/route-category"

export default {
  name: "RouteList",
  components: {RouteAdd, ChildRouteAdd, RouteEdit},
  data() {
    return {
      routeTree: [], // 树形路由数据，通过children属性折叠
      loading: false,
      // 使用对话框和动态组件按需显示新增、编辑
      dialogTitle: "",
      dialogVisible: false,
      currentComponent: {
        name: "",
        props: null
      }
    }
  },
  created() {
    this.loadRouteTree();
  },
  methods: {
    async loadRouteTree() {
      this.loading = true;

      const result = await routeService.getRouteTree()

      if (result.isSuccess()) {
        this.routeTree = result.data
      }

      noticeManager.showMessage(result.msg, result.type)

      this.loading = false;
    },

    categoryFormatter(route) {
      return route.isRequiredAuth ? routeCategory.getCategory(route.category).value : ""
    },

    //////

    async handleSyncBtnClick() {
      noticeManager.showConfirmMessageBox("你确定需要同步路由吗", null, async () => {
        const result = await routeService.syncRoute();

        if (result.isSuccess()) {
          await this.loadRouteTree()
        }

        noticeManager.showMessage(result.msg, result.type)
      })
    },
    handleAddBtnClick() {
      this.dialogTitle = "新增路由"
      this.dialogVisible = true
      this.currentComponent = {
        name: "RouteAdd",
        props: {
          routeTree: this.routeTree
        }
      }
    },

    handleEditBtnClick(route) {
      this.dialogTitle = "编辑路由"
      this.dialogVisible = true
      this.currentComponent = {
        name: "RouteEdit",
        props: {
          routeTree: this.routeTree,
          editedRoute: route
        }
      }
    },
    handleDropDownCommand(command) {
      if (command.name === "add") {
        this.handleAddChildRouteCommand(command.data)
      }
      if (command.name === "delete") {
        this.handleDeleteRouteCommand(command.data)
      }
    },
    handleAddChildRouteCommand(parentRoute) {
      this.dialogTitle = "新增子路由"
      this.dialogVisible = true
      this.currentComponent = {
        name: "ChildRouteAdd",
        props: {
          parentRouteId: parentRoute.id
        }
      }
    },
    handleDeleteRouteCommand(route) {
      noticeManager.showConfirmMessageBox("删除后对应的路由权限、权限分配也会被一起删除！", "你确定要删除当前路由吗?", async () => {
        const result = await routeService.deleteRoute(route.id);

        if (result.isSuccess()) {
          await this.loadRouteTree();
        }

        noticeManager.showMessage(result.msg, result.type);
      })
    },

    handleDialogClose() {
      this.editedRoute = null
      this.dialogVisible = false
    },
    handleComponentClose(isReloadRouteTree) {
      this.handleDialogClose()

      if (isReloadRouteTree) {
        this.loadRouteTree()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.toolbar {
  margin-bottom: 10px;

  .el-button {
    margin: 5px;
  }
}

// 将无子节点的根节点左移，达到对其的目的
:deep(.tableTree) {
  .el-table__row:not([class*='el-table__row--level-']) {
    td:first-child {
      padding-left: 24px;
    }
  }

  .el-table .el-table__expand-icon .el-icon-arrow-right:before {
    content: "\e6d9";
  }

  .el-table .el-table__expand-icon--expanded {
    transform: rotate(0);

    .el-icon-arrow-right:before {
      content: "\e6d8";
    }
  }
}

.el-dropdown-link {
  margin-left: 10px;
  font-size: 12px;
  cursor: pointer;
  color: #409EFF;
}
</style>